(function(){
  var H=2900, base=520, feather=220;
  var rr=document.getElementById('revrect'), rf=document.getElementById('revfeather');
  var fleaf=document.getElementById('fleaf'), bird=document.getElementById('bird');
  var treeEl=document.querySelector('.kvtree .tree');
  if(!rr||!rf||!treeEl) return;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var cl=function(v){return Math.max(0,Math.min(1,v));};
  var ease=function(t){return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2;};
  var lerp=function(a,b,t){return a+(b-a)*t;};

  function frame(){
    var r=treeEl.getBoundingClientRect();
    var p=cl((-r.top+innerHeight*0.35)/(r.height-innerHeight*0.30));
    if(innerWidth<=1024) p=cl(p*1.9);
    var rv=base+p*(H+feather-base);
    rr.setAttribute('height',Math.max(0,rv-feather));
    rf.setAttribute('y',rv-feather);
    if(fleaf){
      var lp=cl((p-0.02)/0.96);
      fleaf.setAttribute('transform','translate('+(600+Math.sin(p*9.5)*120)+','+(500+lp*1930)+') rotate('+(p*820)+')');
      fleaf.setAttribute('opacity',(p>0.03&&p<0.99)?0.95:0);
    }
    if(bird){
      var tt=ease(cl((p-0.20)/0.16));
      bird.setAttribute('transform','translate('+lerp(1180,700,tt)+','+(lerp(210,1150,tt)-Math.sin(tt*Math.PI)*130)+') rotate('+lerp(-16,0,tt)+')');
      bird.setAttribute('opacity',tt>0.001?1:0);
    }
    requestAnimationFrame(frame);
  }

  if(reduce){
    rr.setAttribute('height',H); rf.setAttribute('y',H);
    if(fleaf){fleaf.setAttribute('transform','translate(720,1500) rotate(30)');fleaf.setAttribute('opacity',0.95);}
    if(bird){bird.setAttribute('transform','translate(700,1150)');bird.setAttribute('opacity',1);}
  } else {
    requestAnimationFrame(frame);
  }

  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('in');});},{threshold:0.3});
  document.querySelectorAll('.kvtree .node').forEach(function(n){io.observe(n);});

  var land=document.querySelector('.kvtree .landscape');
  var sv=document.getElementById('tree');

  function posLand(){
    if(!land||!sv) return;
    if(innerWidth<=1024){ land.style.top=''; return; }
    var lh=land.getBoundingClientRect().height || (innerWidth*470/1600);
    var sr=sv.getBoundingClientRect(), tr=treeEl.getBoundingClientRect();
    var trunkFoot=(sr.top-tr.top)+sr.height*0.8517;
    land.style.top=(trunkFoot-(300/470)*lh)+'px';
  }

  function posGround(){
    var pin=document.querySelector('.kvtree .pin'), g=document.querySelector('.kvtree .groundm');
    if(!pin||!sv||!g) return;
    if(innerWidth>1024){ g.style.top=''; return; }
    var pr=pin.getBoundingClientRect(), sr=sv.getBoundingClientRect();
    g.style.top=((sr.top-pr.top)+sr.height*0.8517)+'px';
  }

  function reposition(){ posLand(); posGround(); }
  addEventListener('resize',reposition);
  addEventListener('load',reposition);
  setTimeout(reposition,150);
  setTimeout(reposition,600);
  reposition();
})();
